import { useFocusEffect } from "expo-router";
import { useCallback, useState } from "react";

export const useTimedEvent = (time_ms: number) => {
  const [enabled, setEnabled] = useState<boolean>(false);
  const [waitTimeout, setWaitTimeout] = useState<ReturnType<typeof setTimeout> | null>(null);

  useFocusEffect(
    useCallback(() => {
      start();
      return terminate;
    }, []),
  );

  const reset = useCallback(() => {
    terminate();
    start();
  }, []);

  const start = useCallback(() => {
    if (!waitTimeout) {
      setEnabled(false);
      setWaitTimeout(
        setTimeout(() => {
          setEnabled(true);
          setWaitTimeout(null);
        }, time_ms),
      );
    }
  }, [time_ms, waitTimeout]);

  const terminate = useCallback(() => {
    if (waitTimeout) {
      clearTimeout(waitTimeout);
      setWaitTimeout(null);
    }
  }, [waitTimeout]);

  return {
    enabled,
    reset,
    terminate,
  };
};
